import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	max-width: 1280px;
	margin: 0 auto;
	padding: 50px 20px;
	color: ${CSSVars.black};
	
	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 100px 40px;
	}

	h3 {
		text-align: center;
		font-size: ${CSSVars.fontSize2XL};
		margin: 0 auto 50px;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			margin: 0 auto 100px;
			max-width: 780px;
		}
	}

	.affiliates-feature {
		margin-bottom: 100px;
	}
`;
